import { page, bootstrapSelect } from '../init'

$(function() {
  if (page.controller() === 'profile_groups') {
    console.debug('[JS] bootstrap-select')
    bootstrapSelect.trigger({showSubtext: true})
  }
})
